import config from 'config';

export default [
  '$window', '$document',
  function lazyImg($window, $document) {
    return {
      restrict: 'A',
      link: (scope, elm, attrs) => {
        let $el = $(elm[0]),
          image = new Image();

        let scrollFunc = () => {
          if (angular.element($window).scrollTop() + angular.element($window).height() >= $el.offset().top) {
            angular.element(image).on('load', imageLoad);
            image.src = attrs.lazyImg;
            $document.off('scroll', scrollFunc);
          }
        };

        let imageLoad = () => {
          $el.attr('src', attrs.lazyImg);
          angular.element(image).off('load', imageLoad);
        };

        $document.on('scroll', scrollFunc);

        elm.on('$destroy', () => {
          $document.off('scroll', scrollFunc);
          angular.element(image).off('load', imageLoad);
        });

        $el.attr('src', `/assets/customer-ui/images/ring.gif`);
        // Run on link to load visible images.
        scrollFunc();
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/lazy-img/lazy-img.dir.js